import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-6 overflow-hidden" data-id="element-87">
      <div className="max-w-4xl mx-auto text-center" data-id="element-88">
        <FadeIn data-id="element-89">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brown-900 leading-tight mb-6" data-id="element-90">
            "En Mi Casa Serviremos al Señor": <br className="hidden md:block" data-id="element-91" />
            <span className="text-gold-600" data-id="element-92">
              Restablece el Altar de Paz en tu Hogar
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-93">
          <h2 className="text-xl md:text-2xl text-brown-800 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-94">
            Descubre el Protocolo Bíblico de Amor y Autoridad para Sanar la
            Atmósfera de tu Familia y Expulsar la Discordia en 24 Horas.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-95">
          <div className="relative mx-auto max-w-2xl mb-16 rounded-xl overflow-hidden shadow-2xl ring-1 ring-black/5" data-id="element-96">
            <img src="https://cdn.magicpatterns.com/uploads/bvvsaHpEi5AskQWLExjLSr/el_escudo_del_hogar_cristiano.png" alt="El Escudo del Hogar Cristiano" className="w-full h-auto object-cover" data-id="element-97" />
          </div>
        </FadeIn>

        <FadeIn delay={0.3} className="max-w-3xl mx-auto text-left space-y-6 text-lg md:text-xl text-brown-800 leading-relaxed" data-id="element-98">
          <p data-id="element-99">
            La Biblia dice que la sabiduría edifica la casa, pero la necedad la
            destruye con sus propias manos. Hoy, el ruido de los gritos y la
            pesadez en el ambiente han robado el refugio que Dios diseñó para
            ti.
          </p>
          <p data-id="element-100">
            Sientes que el gozo se ha escapado por las ventanas y que una sombra
            de tristeza o pelea se ha instalado en tu mesa. Pero hay una promesa
            para ti:
          </p>

          <blockquote className="border-l-4 border-gold-500 pl-6 py-2 my-8 italic text-xl md:text-2xl font-serif text-brown-900 bg-cream-100/50 rounded-r-lg" data-id="element-101">
            "Y mi pueblo habitará en morada de paz, en habitaciones seguras"{' '}
            <br data-id="element-102" />
            <span className="text-base text-gold-600 not-italic mt-2 block" data-id="element-103">
              — Isaías 32:18
            </span>
          </blockquote>
        </FadeIn>

        <FadeIn delay={0.4} className="mt-8" data-id="element-104">
          <Button href="https://thealphamethods.com/cart/44267718836310:1" target="_blank" rel="noopener noreferrer" data-id="element-105">
            SÍ, QUIERO RESTAURAR MI HOGAR POR SOLO $6.36
          </Button>
        </FadeIn>
      </div>
    </section>;
}